export const statuses = [
  'PENDING',
  'SUCCESS',
  'BLOCKED',
  'CANCELED',
  'DECLINED'
]
